import PropTypes from 'prop-types';

const propTypes = {
    nodeData: PropTypes.object.isRequired
};

const OrgChartNode = (props:any) => {
    const {nodeData} = props;

    return (
        <div>
            {nodeData.title ? <div className='position'>{nodeData.title}</div> : null}
            {nodeData.name  ? <div className='fullname'>{nodeData.name}</div>  : null}
        </div>
    );
}

OrgChartNode.propTypes = propTypes;

export default OrgChartNode;